import { ASSETS_BUCKET } from '@/lib/constants';

function LogoTextHorizontal() {
    return (
        <img
            src={`${ASSETS_BUCKET}marketing/logo-text-horizontal.png`}
            alt='logo-text-horizontal'
            style={{ width: 'auto', height: '100%' }}
        />
    );
}

export default LogoTextHorizontal;
